import React from 'react';
import { useUpdateProduct } from './presenter';
import { ProductUpdateView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';
import { useConfirm } from '../../../components/ui/ConfirmDialog';
import { useToast } from '../../../components/ui/Toaster';

type Props = {
  id: string;
  navigate: (r: Route) => void;
};

const ProductUpdatePage: React.FC<Props> = ({ id, navigate }) => {
  const vm = useUpdateProduct(id, () => navigate({ name: 'products/index' }));
  const confirm = useConfirm();
  const toast = useToast();
  return (
    <ProductUpdateView
      form={vm.form}
      setField={vm.setField as any}
      setImageFile={vm.setImageFile}
      removeImage={vm.removeImage}
      setRemoveImage={vm.setRemoveImage}
      onSubmit={async () => {
        const ok = await confirm({ title: 'Update Product', message: 'Apply these changes?', confirmText: 'Update' });
        if (!ok) return;
        await vm.submit();
        toast.success('Product updated');
      }}
      onCancel={() => navigate({ name: 'products/index' as any })}
      loading={vm.loading}
      error={vm.error}
    />
  );
};

export default ProductUpdatePage;
